<script>
    import Echo from "laravel-echo"

	export default {
		props: {
		},
		data: function(){
            return {
                loaded: false,
                failedToLoad: false,
                events: [],
                apiBase: "OVERLOAD-ME",
                videoInitialised: false,
                gruveoLoaded: false,
                gruveoLoadedAttempts: 0,
				// Do not add this in. Do not ask me why this causes the Gruveo embed to
				// start throwing those __v_ref errors again, but it does. So changing it
				// to a non-local component property makes it work again, but declaring that
				// property beforehand breaks it again. MADNESS! We need to replace Gruveo.
				//gruveo_embed: null,
                tableauInitialised: false,
                browseAloudInitialised: false,
                echo_host: null,
                echo_options: null,
                echo_domain_prefix: "",
                showEchoStatusNotifications: false,
                serviceWorkerName: null,
                isPushAvailable: false,
                isPushBlocked: false,
                isPushEnabled: false,
                deferredInstallPrompt: null,
                installable: false,
                user_settings: {"sort": {"field":"created_at","dir":"desc"}, "per_page": 10, "site_id": ""},
                lookup: {
                    user_roles: {},
                    filters: {},
                    relatedData: {},
                    cache: {},
                    staff: [],
                    tags: [],
                    test: [],
                    user_titles: {},
                    user_assignment_today: {},
                    user_assignment: {},
                    user_completed_today: {},
                    group_assignment_today: {},
                    group_assignment: {},
                    group_completed_today: {},
                    transferred_provider_assignment: {},
                    transferred_provider_assignment_today: {},
                    shared_provider_assignment: {},
                    shared_provider_assignment_today: {},
                    service_status: {
                        OFFLINE: 1,
                        OOH_AVAILABLE: 2,
                        OOH_UNAVAILABLE: 3,
                        AVAILABLE: 4
                    },
                    langs: {
                        'cy' : 'Cymraeg',
                        'en' : 'English',
                        'fr' : 'Français',
                    },
                    dayNames: {
                    },
                },
                locale: "en",
                stale: false,
                visibility: "visible",
				appvisible: false,
                focused: true,
                activityTimer: null,
                activityTimerCheckTimeout: 5 * 60 * 1000, // every 5 minutes
                inactivityTimeout: 60 * 60 * 1000, // 60 minutes

                // For testing purposes - you may also want to change the setconfig
                // middleware value, in web.php, to match when testing.
                //activityTimerCheckTimeout: 1 * 60 * 1000, // every 10 seconds
                //inactivityTimeout: 1 * 60 * 1000, // 1 minute
                inactivityTime: 0,
                
                activityEventMonitoring: false,
                activityEvents: [],
                isActive: false,
                coreUpdateTimer: null,
                coreUpdateTimerMaxTimeout: 300000,
                encryptStorage: null,
                minuteOffset: 0,
                // We want the default for embed to be numeric, rather than a boolean, so
                // that the brand keys look sensible.
                embed: 0,
                pendingWritebackWarningHours: 24,
                // 60 minutes
                checkPendingMaxAgeTimeout: 1000 * 60 * 60 * 1,
            }
		},
        computed: {
            
            supported_browser() {
                return window.supported_browser;
            },
            video_enabled() {
                return this.environment_settings.MIX_ENABLE_VIDEO 
                        && this.provider 
                        && this.provider.video_available 
                        && this.provider.video_enabled;
            },
            video_ready() {
                return this.gruveoLoaded;
            }
        },
        created() {
            this.setLocale();
        },
        mounted() {
            axios.defaults.headers.common['X-Api-Version'] = window.appVersionNumber;
            this.registerServiceWorker()
            this.registerInstallHandler();
            this.setLocale();
        },
		methods: {
            /**
             * Untested unregistration. Would need to use it if we get in trouble with
             * the service worker going faulty. Normal lifecycle to reload is 24hrs.
             * This function should unload any existing service workes and then
             * reload each client to make sure it is completely removed.
             */
            // unregisterServiceWorker() {
            //     navigator.serviceWorker.getRegistrations().then(
            //         function(registrations) {
            //             for(let registration of registrations) {
            //                 registration.unregister()
            //                 .then(function() {
            //                     return self.clients.matchAll();
            //                 })
            //                 .then(function(clients) {
            //                     clients.forEach(client => {
            //                         if (client.url && "navigate" in client){
            //                             client.navigate(client.url);
            //                         }
            //                     });

            //                 });
            //             }
            //         });
            // },notification
            updateCore(backoff) {
                if(this.coreUpdateTimer) {
                    // Toyed with the idea of continual back-off, but we would need some way to say enough is enough.
                    //clearTimeout(this.resultsRequestTimer);
                    //this.addNotification({type: "warning", content: 'Waiting for request update.'});
                    console.log('Waiting for core update.')
                    return;
                }

                if (typeof backoff === 'undefined') {
					backoff = Math.random() * 120000;
				}

                console.log('Backing off for ' + (backoff / 1000) + ' seconds.');
                this.coreUpdateTimer = setTimeout(() => {
                    // Clear has to happen outside of the get as the query may have already occurred if
                    // we wait for the promise to return
                    this.coreUpdateTimer = null;
                    this.checkVersion();
                    if(this.isLoggedIn()) {
                        this.loadCore();
                    }
                    else if(this.loadCoreMin) {
                        this.loadCoreMin();
                    }
                    //this.addNotification({type: "success", content: 'Request timeout update after ' + (backoff / 1000) + 'seconds.'});
                    console.log('Core timeout update after ' + (backoff / 1000) + ' seconds.')
                }, backoff);
            },
            registerInstallHandler() {
                if (this.installable) {
                    window.addEventListener('beforeinstallprompt', event => {

                        // Prevent Chrome 67 and earlier from automatically showing the prompt
                        event.preventDefault();

                        // Stash the event so it can be triggered later.
                        this.deferredInstallPrompt = event;
                    });
                }
            },
            isFunction(functionToCheck) {
                return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
            },
            registerServiceWorker() {
                try {
                    if (this.serviceWorkerName && ('serviceWorker' in navigator) && this.isFunction(navigator.serviceWorker.register)) {
                        navigator.serviceWorker.register(this.serviceWorkerName)
                            .then(() => this.initialiseServiceWorker())
                    }
                    else {
                        console.log('Service workers aren\'t supported in this browser.')
                    }
                }
                catch(e) {
                    console.error("Error registering service worker.")
                    // We ignore any ReferenceError exceptions here.
                }
            },
            initialiseServiceWorker () {
                try {
                    if(typeof ServiceWorkerRegistration != "undefined") {
                        if ('showNotification' in ServiceWorkerRegistration.prototype) {
                            this.isPushAvailable = true;
                        }
                        else {
                            console.log('Notifications aren\'t supported.')
                            this.isPushAvailable = false;
                            return
                        }

                        if (Notification.permission === 'denied') {
                            console.log('The user has blocked notifications.');
                            this.isPushBlocked = true;
                            return
                        }
                        else {
                            this.isPushBlocked = false;
                        }

                        if (!('PushManager' in window)) {
                            console.log('Push messaging isn\'t supported.');
                            this.isPushAvailable = false;
                            return
                        }

                        navigator.serviceWorker.ready.then(registration => {
                            registration.pushManager.getSubscription()
                            .then(subscription => {
                                console.log("Subscription:" + JSON.stringify(subscription));
                                //this.pushButtonDisabled = false
                                if (!subscription) {
                                    console.log("No subscription found.");
                                    return;
                                }
                                //this.updateSubscription(subscription)
                                this.isPushEnabled = true
                            })
                            .catch(e => {
                                console.log('Error during getSubscription()', e)
                            })
                        })
                    }
                }
                catch(e) {
                    console.error("Error setting up service worker.")
                    // We ignore any ReferenceError exceptions here.
                }
            },
            checkPusherConnect(url, port, path, timeout) {
                console.log("Testing pusher");
                return new Promise((resolve, reject) => {
                    var errAlready = false;
                    timeout = timeout || 15000;
                    var options = {reconnection: false, timeout: timeout}
                    var pusher_test = new window.Pusher(window.environment_settings.MIX_PUSHER_APP_KEY, {
                        forceTLS: true,
                        cluster: window.environment_settings.MIX_PUSHER_APP_CLUSTER,
                    });
                    
                    // success
                    pusher_test.connection.bind("connected", function() {
                        clearTimeout(timer);
                        pusher_test.disconnect();
                        resolve();
                    });

                    // set our own timeout in case the socket ends some other way than what we are listening for
                    var timer = setTimeout(function() {
                        timer = null;
                        error("local timeout");
                    }, timeout);

                    // common error handler
                    function error(data) {
                        if (timer) {
                            clearTimeout(timer);
                            timer = null;
                        }
                        if (!errAlready) {
                            errAlready = true;
                            try {
                                pusher_test.disconnect();
                            }
                            catch(e) {
                                // Do nothing. If the connection fails to disconnect, we don't care,
                                // but we have to try and disconnect it just in case it has resources
                                // open
                            }
                            reject(data);
                        }
                    }

                    // // errors
                    pusher_test.connection.bind("unavailable", error);
                    pusher_test.connection.bind("failed", error);
                    pusher_test.connection.bind("disonnected", error);

                });
            },
            checkPusher(timeout, failover) {
                if(window.Echo) {
                    return Promise.resolve({type: 'previous'});
                }

                //return Promise.resolve({type: 'direct'});
                return new Promise((resolve, reject) => {
                    
                    this.checkPusherConnect(timeout).then(() => {
                        console.log("Successfully connected to pusher on " + this.echo_host + ":" + this.echo_port);
                        resolve({type: 'direct'});
                    }, (reason) => {
                        
                        console.log("No fallback for websocket connection possible");
                        reject();
                    });
                });
            },
            initServerTime() {
                return axios.get(this.apiBase + "/pt/" + this.provider.id).then((res) => {
                    //this.serverTime = this.moment(res.data.local);
                    this.$root.minuteOffset = -this.moment.utc().diff(res.data.utc, 'minutes');
                }).catch((error) => {
                    
                });
            },
            initEcho() {
                if(window.Echo) {
                    // Set it in all three places (so you see the same keys everywhere)
                    window.Echo.connector.options.auth.headers['Authorization'] = 'Bearer ' + window.api_token + ":" + window.provider_id;
                    window.Echo.connector.pusher.connection.options.auth.headers['Authorization'] = 'Bearer ' + window.api_token + ":" + window.provider_id;
                    
                    // This is the important one that is used in the live connection
                    window.Echo.connector.pusher.config.auth.headers['Authorization'] = 'Bearer ' + window.api_token + ":" + window.provider_id;
                    return;
                }
                window.Echo = new Echo({
                    broadcaster: 'pusher',
                    key: window.environment_settings.MIX_PUSHER_APP_KEY,
                    cluster: window.environment_settings.MIX_PUSHER_APP_CLUSTER,
                    // wsHost: this.echo_host,
                    // wsPort: this.echo_port,
                    // wssHost: this.echo_host,
                    // wssPort: this.echo_port,
                    // // httpHost: this.echo_host,
                    // httpPort: this.echo_host,
                    forceTLS: true,
                    // disableStats: true,
                    auth: {
                        headers: {
                            Authorization: 'Bearer ' + window.api_token + ":" + window.provider_id
                        },
                    },
                    //authEndpoint: window.environment_settings.MIX_LOCAL_SOCKETIO_PROTOCOL + "://" + this.echo_host + ":" + this.echo_port + "/broadcasting/auth",
                    // enabledTransports: ['ws', 'wss'],
                    // enabledTransports: ['xhr_polling']
                });

                window.Echo.connector.pusher.connection.bind('connected', function(){
                    console.log('connected', window.Echo.socketId());
                    if(this.showEchoStatusNotifications) {
                        this.addNotification({key: 'connect-attempt', type: "success", content: 'Connected to server'});
                    }
                    this.connected = true;
                    this.setLoading(false);
                    this.reloadIfStale()
                }.bind(this));

                window.Echo.connector.pusher.connection.bind('state_change', function(states) {
                    // states = {previous: 'oldState', current: 'newState'}
                    console.warn(states);
                    if(states.previous == "connected" && states.current == "connecting") {
                        this.connected = false;
                        this.setStale(true);
                    }
                }.bind(this));
            },
            deInitEcho() {
                console.log("Deinitialising websockets");
                this.deInitAllChannels();
                window.Echo.connector.pusher.disconnect();
            },
            checkVersion() {
                console.log("Starting a version check ... ");
                axios.get('/api/v0/versioncheck').then((res) => {
                    console.log("Version okay: " + window.appVersionNumber + " == " + res.data.version);
                }).catch((error) => {
                    if(typeof error === 'object' && error !== null && typeof error.response === 'object' && error.response !== null) {
                        console.log("Version check failed: " + error.response.data);
                    }
                    this.handleError(error, "application version");
                });
            },
            checkActivity() {
                console.log("Checking activity: " + this.isActive + ": " + this.inactivityTime);
                
                this.isActive = false;
                
                if(this.inactivityTime >= this.inactivityTimeout) {

                    console.log("Activity timer expired. Logging out.");
                    window.location = "/logout";
                    // axios.get('/patient/logout', this.auth).then((res) => {
                    //     this.addNotification({type: "success", content: this.$t('translations.logged_out_successfully') });
                    //     window.api_token = null;
                    //     this.api_token = window.api_token;

                    //     axios.defaults.headers.common['Authorization'] = 'Bearer ' + window.api_token;

                    //     this.loadCore(true, {name: "loginForm"});
                    // }).catch((error) => {
                    //     console.log("Error auto logging out")
                    //     window.location = "/";
                    // });
                }
            },
            // We do it like this so that we only check every minute, otherwise the events,
            // especially the mousemove event causes too many setTimeout resets. This way
            // we only ever set a flag to indicate some activity was seen in the last minute.
            initActivityMonitoring() {
                if(!this.activityEventMonitoring) {
                    var moveEvents = ["mousemove", "mousedown", "keypress", "wheel", "touchstart"];
                    this.activityEventMonitoring = true;
                    for(var index in moveEvents) {
                        this.activityEvents.push({type: moveEvents[index], listener: this.recordActivity});
                        window.addEventListener(moveEvents[index], this.recordActivity);
                        //window.addEventListener(moveEvents[index], this.setRead, {once: true});
                    }
                    // window.addEventListener("beforeunload", (event) => {
                    //     this.refreshSessionCookieAsync();
                    // },{ once: true });
                    this.activityTimer = window.setInterval(() => {
                        if(this.isActive) {
                            this.inactivityTime = 0;
                            this.refreshSessionCookie();
                        }
                        else {
                            this.inactivityTime += this.activityTimerCheckTimeout
                        }
                        this.checkActivity();
                    }, this.activityTimerCheckTimeout);
                }
            },
            refreshSessionCookie() {
                axios.get('/refreshCookie').then((res) => {

                }).catch((error) => {

                });
            },
            async refreshSessionCookieAsync() {
                try{
                    console.info("Attempting to refresh cookie before unloading");

                    // This is a version using fetch, with keepalive, which doesn't work :D
                    // const options = {
                    //     keepalive: true,
                    // };
                    // const myRequest = new Request("/refreshCookie", options);
                    // let myKeepAlive = myRequest.keepalive; // true)
                    // fetch(myRequest);

                    // This is a version that uses a POST request via the inbuilt sendBeacon command
                    // ... and it doesn't work :(
                    //navigator.sendBeacon('/refreshCookieBeacon');

                    
                    // This is our original version that uses a clean axios session, so
                    // that our api headers aren't present. Works okay, but I don't think we need
                    // it now.
                    
                    //var axiosClean = axios.create();
                    //await axiosClean.get('/refreshCookie')
                    
                    await axios.get('/refreshCookie')
                    
                    console.info("Cookie refreshed");
                }
                catch(e) {
                    console.error("Cookie didn't refresh");
                    console.error(e);
                }
            },
            deinitReadActivityMonitor() {
				this.activityEventMonitoring = false;
				while(this.activityEvents.length) {
					var event = this.events.pop();
					//console.log("removing: " + event.type + " - " + event.listener);
					window.removeEventListener(event.type, event.listener);
				}
			},
            isLoggedIn() {
                if(typeof this.api_token == "undefined" || this.api_token == null) {
                    return false;
                }
                return true;
            },
            recordActivity() {
                this.isActive = true;
            },
            // resetActivityTimer() {
            //     console.log("Activity detected. Resetting activity timer: " + (this.inactivityTimeout / 1000) + " seconds");
            //     if(this.activityTimer) {
            //         window.clearTimeout(this.activityTimer);
            //         this.activityTimer = null;
            //     }
            //     this.activityTimer = window.setTimeout(() => {
            //         console.log("Activity timer expired. Logging out.");
            //         window.location = "/logout";
            //         // axios.get('/patient/logout', this.auth).then((res) => {
            //         //     this.addNotification({type: "success", content: this.$t('translations.logged_out_successfully') });
            //         //     window.api_token = null;
            //         //     this.api_token = window.api_token;

            //         //     axios.defaults.headers.common['Authorization'] = 'Bearer ' + window.api_token;

            //         //     this.loadCore(true, {name: "loginForm"});
            //         // }).catch((error) => {
            //         //     console.log("Error auto logging out")
            //         //     window.location = "/";
            //         // });
            //     }, this.inactivityTimeout);
            // },
            loadUser() {
                return axios.get(this.apiBase + '/users/me');
            },
            loadProvider() {
                var practice_code = this.$root.practice_code;
                if(practice_code == null) {
                    try {
                        if(typeof localStorage === 'object') {
                            practice_code = localStorage.getItem('practice_code');
                        }
                    }
                    catch(e) {

                    }
                }
                // if(!practice_code) {
                //     practice_code = null;
                // }
                if(practice_code) {
                    return axios.get(this.apiBase + '/providers/getByCode/' + practice_code);
                }
                else {
                    return Promise.resolve({});
                }
            },
            loadLookup(endpoint) {
                return axios.get(this.apiBase + '/' + endpoint + '?p=0');
            },
            setLookup(lookup, name) {
                if(name) {
                    // Have to clear the array and then add new members, otherwise
                    // the data reactivity will be lost.
                    if(Array.isArray(this.lookup[name])) {
                        this.lookup[name].splice(0, this.lookup[name].length);
                        this.lookup[name].push.apply(this.lookup[name], lookup);
                    }
                    else {
                        this.lookup[name] = lookup;
                    }
                }
                else {
                    for(var index in lookup) {
                        if(Array.isArray(this.lookup[index])) {
                            this.lookup[index].splice(0, this.lookup[index].length);
                            this.lookup[index].push.apply(this.lookup[index], lookup[index]);
                        }
                        else {
                            this.lookup[index] = lookup[index];
                        }

                    }
                }
            },
			getAppVersion() {
	            return window.appVersion;
	        },
	        getAppVersionLink() {
	            return window.appVersionLink;
            },
            getActiveNotice() {
                axios.get(this.apiBase + '/news/getActiveNotice').then((res) => {
                    if(res.data.notice) {
                        this.updateNotice(res.data.notice);
                    }
                }).catch((error) => {

                });
            },
            checkPendingMaxAge() {
                axios.get(this.apiBase + '/filing/pendingAge').then((res) => {
                    if(res.data) {
                        if(this.moment().diff(this.moment(res.data), "hours") > this.pendingWritebackWarningHours) {
                            this.addNotification({type: "danger", key: 'maxage', timeout: 0, html: true,
                                content: this.autobrand('errors.writeback_max_pending_age_warning', {"hours": this.pendingWritebackWarningHours})});
                        }
                        
                    }
                    //setTimeout(this.checkPendingMaxAge, 1000 * 60 * 60 * 2);
                    setTimeout(this.checkPendingMaxAge, this.checkPendingMaxAgeTimeout);
                }).catch((error) => {

                });
            },
            getNoticeHash(notice) {
                if(notice && notice.id && notice.updated_at) {
                    //return ("" + notice.start_at + notice.end_at + notice.content + notice.title).hashCode()
                    return ("" + notice.id + "_" + notice.updated_at);
                }
                return null;
            },
            setLastDismissedNotice(notice) {
                this.setSetting("last_dismissed_notice_hash", this.getNoticeHash(notice));
            },
            updateNotice(notice) {
                if(notice) {
                    if(this.getSetting("last_dismissed_notice_hash") !== this.getNoticeHash(notice)) {
                        this.removeNotification('notice');
                        this.addNotification({type: "info", top: true, dismissButton: () => {this.setLastDismissedNotice(notice);}, title:notice.title, content: notice.content, timeout: 0, key: 'notice'});
                    }
                }
                else {
                    this.removeNotification('notice');
                }
            },
            initVisibilityHandlers() {
                // Not using focus and blur currently.
                // window.addEventListener("focus", function(event) {
                //     this.focused = true;
                //     console.info("focused: " + this.focused);
                //     this.reloadIfStale();
                //     this.setSleeping();

                // }.bind(this));
                // window.addEventListener("blur", function(event) {
                //     this.focused = false;
                //     console.info("focused: " + this.focused);
                //     this.setSleeping();
                // }.bind(this));
                // THIS MAY NOT WORK FOR INITIALISING AS IT USES DOCUMENT NOT WINDOW
                // // document.hasFocus()
                
                document.removeEventListener('visibilitychange', this.visibilityChange);
                document.addEventListener('visibilitychange', this.visibilityChange);
                    
                this.visibility = document.visibilityState;
                
            },
            /**
             * Checking activity: false: 900000 patient-app.js:2:1266752
             * Activity timer expired. Logging out. patient-app.js:2:1266889
             * Attempting to refresh cookie before unloading
             */
            visibilityChange() {
                this.refreshSessionCookieAsync();
                this.visibility = document.visibilityState;
                console.info("visibility: " + this.visibility);
                this.reloadIfStale();
                this.setSleeping();
            },
            
            setSleeping() {
                // if (this.visibility === 'visible' && this.focused) {
                //     this.$refs.sleepingContainer.style.display = "none";
                // }
                // else {
                //     this.$refs.sleepingContainer.style.display = "block";
                // }
            },
            setStale(state) {
                this.stale = state;
                console.info("set stale: " + this.stale);
            },
            reloadIfStale() {
                console.info("stale: " + this.stale);
                if (this.appActive() && this.stale) {
                    console.info("reloading core");
                    this.updateCore();
                    this.stale = false;
                }
            },
            checkGruveo() {
                if(typeof Gruveo === "object" && Gruveo.Embed) {
                    this.gruveoLoaded = true;
                    clearInterval(this.gruveoWatch);
                    return true;
                }
                this.gruveoLoadedAttempts++;
                if(this.gruveoLoadedAttempts > 60) {
                    clearInterval(this.gruveoWatch);
                }
            },
			initVideo() {
				if(!this.videoInitialised && this.provider && this.video_enabled) {
					var tag = document.createElement("script");
					tag.src = "https://www.gruveo.com/embed-api/";
					var firstScriptTag = document.getElementsByTagName("script")[0];
					firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

                    this.videoInitialised = true;
                    this.gruveoWatch = setInterval(this.checkGruveo, 1000);
				}
            },
            initTableau() {
                // Not used currently as the javascript tries to use document.write, so cannot be
                // loaded asynchronously. It is now included in the blade file.
                if(!this.tableauInitialised) {
					var tag = document.createElement("script");
                    tag.src = "https://public.tableau.com/javascripts/api/tableau-2.min.js";
                    tag.defer = true;
                    tag.async = true;
					var firstScriptTag = document.getElementsByTagName("script")[0];
					firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

					this.tableauInitialised = true;
				}
            },
			// initNickelled() {
			//     if(this.nickelledReady() && this.$root.user && this.$root.user.id) {
			//         var data = {
			//             userId: this.$root.user.id,
			//             missionDock: {
			//                 missionDockId: 475
			//             }
			//         };
			//         // This code looks a bit hacky to me, but it was supplied by David Beaty
			//         window.NickelledLaunchers.settings = data; //Manually assign the settings to the Launchers
			//         window.NickelledLaunchers._init(); // Hidden init code
			//         window.NickelledLaunchers.show();
            //
			//         return true;
			//     }
			//     return false;
			// },
			initBrowseAloud() {
				if(this.environment_settings.MIX_ENABLE_BROWSEALOUD && !this.browseAloudInitialised) {
					window._baTheme=1, window._baMode='Accessibility Options', window._baUseCookies=true, window._baHideOnLoad=false;

					var tag = document.createElement("script");
					tag.src = "https://www.browsealoud.com/plus/scripts/ba.js";
					var firstScriptTag = document.getElementsByTagName("script")[0];
					firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

					this.browseAloudInitialised = true;
				}
			},
            getUserSettings() {
                if(this.$root.user && this.$root.user.id) {
                    try {
                        var value = localStorage.getItem("user_settings_" + this.$root.user.id)
                        if (value !== null) {
                            this.user_settings = JSON.parse(value);
                            return;
                        }
                    }
                    catch(e) {

                    }

                    try {
                        localStorage.setItem("user_settings_" + this.$root.user.id, JSON.stringify(this.$root.user_settings));
                    }
                    catch(e) {

                    }
                }

            },
            deInitChannels(channelName) {
                Object.keys(window.Echo.connector.channels).forEach(value => {
                    console.info("Looking at: " + value + ": to match: " + channelName);
                    if((channelName.slice(-1) == "." && value.startsWith(channelName))
                            || channelName == value) {
                        console.info("Leaving: " + value)
                        window.Echo.leave(value);
                    }
                })
            },
            deInitAllChannels() {
                Object.keys(window.Echo.connector.channels).forEach(value => {
                    window.Echo.leave(value);
                })
            },
            switchProvider(event) {
                this.$router.push({path: "/home"});
                this.$root.firstRoute = {path: "/home"};
                window.provider_id = event.target.value;
                this.setSetting("provider_id", event.target.value);
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.api_token + ":" + event.target.value;
                var currentPath = this.$route.path;

                // Clear the cache
                this.$root.lookup.filters = {};
                this.$root.lookup.relatedData = {};



                // Re-load the core
                //this.setLoading(true);
                this.loadCore(true).then(() => {
                    //this.$router.push({path: currentPath});
                })
            },
            getLocale() {
                var locale = window.getNavigatorLanguage();
                console.log("Got browser locale " + locale);

                if(this.provider && this.provider.locale) {
                    console.log("Overriding with provider locale: " + this.provider.locale)
                    locale = this.provider.locale;
                }

                if(this.user && this.user.locale) {
                    console.log("Overriding with user locale: " + this.user.locale)
                    locale = this.user.locale;
                }

                if(!this.$root.lookup.langs[locale]) {
                    console.log("Locale " + locale + " is not supported. Resetting to 'en'");
                    locale = 'en';
                }

                return locale;
            },
            setLocale(locale = null) {
                if(!locale) {
                    locale = this.getLocale();
                }
                this.locale = locale;
                Vue.i18n.set(this.locale);
                this.moment.locale(this.locale);

                // Not the most elegant solution, but we had this array pre-translations, to help
                // with the annoying 0 or 1 based day numbering (ISO standard is 1 based, with Monday as
                // the first day of the week).
                this.lookup.dayNames = {
                    1: this.moment().weekday(1).format('dddd'),
                    2: this.moment().weekday(2).format('dddd'),
                    3: this.moment().weekday(3).format('dddd'),
                    4: this.moment().weekday(4).format('dddd'),
                    5: this.moment().weekday(5).format('dddd'),
                    6: this.moment().weekday(6).format('dddd'),
                    7: this.moment().weekday(0).format('dddd'),
                };


                // We also set the locale in some common headers for the API.
                // This is only used as a fallback when there is no user logged in yet,
                // for example during registration.
                axios.defaults.headers.common['X-Locale'] = locale;
            },
            async freshdeskSetUser() {
                if(typeof this.user === "object" && window.FreshworksWidget) {
                    try {
                        FreshworksWidget('identify', 'ticketForm', {
                            name: this.user.forenames + " " + this.user.surname,
                            email: this.user.email,
                            custom_fields: {
                                cf_practice_name: this.user.provider.name,
                                cf_ods_code: this.user.provider.practice_code,
                            }
                        });

                        FreshworksWidget('disable', 'ticketForm', 
                        [
                            'name', 'email', 'custom_fields.cf_practice_name', 'custom_fields.cf_ods_code'
                        ]);
                        
                        // window.zE('webWidget', 'updateSettings', {
                        //     webWidget: {
                        //         contactForm: {
                        //           fields: [
                        //               { id: 360002594877, prefill: { '*': this.user.provider.practice_code } },
                        //               { id: 360002594897, prefill: { '*': this.user.provider.name } }
                        //           ]
                        //         }
                        //     }
                        // });
                    }
                    catch(e) {

                    }
                }
            },
            addOrUpdateStaff(staff) {
                var found = false;

                if(this.lookup.staff && Array.isArray(this.lookup.staff)) {
                    //console.log("Processing request update.");
                    for(var index in this.lookup.staff) {
                        if(this.lookup.staff[index].id == staff.id) {
                            found = true;
                            if(staff.deleted_at) {
                                this.lookup.staff.splice(index, 1);
                            }
                            else {
                                for (var attrname in staff) {
                                    this.lookup.staff[index][attrname] = staff[attrname];
                                }
                            }
                        }
                    }
                    
                    if(this.$root.user.id == staff.id) {
                        //console.info(JSON.stringify(staff, null, true));
                        for (var attrname in staff) {
                            // Need to update this by attribute as the sub-objects aren't included with these staff updates.
                            if(attrname == "provider") {
								// Only update the provider details if they are for our currently logged in provider.
								if(staff.provider["id"] == this.$root.user.provider["id"]) {
									for (var attrname2 in staff.provider) {
                                 	   this.$root.user.provider[attrname2] = staff.provider[attrname2];
                                	}
								}

								// NOTE - These next two cases won't happen currently because the user is only listening
								// on core.{current_provider}. ALSO we aren't currently including the user_providers
								// array in these updates, so new provider accounts won't be added. See the UpdateFull
								// function in UpdateStaff for that relationship (currently commented out as we tested it
								// but didn't want to include it in the task it was part of).

								// Update the existing provider in our provider list, if we have it.
								var existing_provider_index = this.$root.user.user_provider.findIndex(obj => obj.id == staff.provider["id"]);
								if(existing_provider_index) {
									for (var attrname2 in staff.provider) {
                                 	   this.$root.user.user_provider[existing_provider_index][attrname2] = staff.provider[attrname2];
                                	}
								}
								// Otherwise push it on to our provider list
								else {
									this.$root.user.user_provider.push(staff.provider);
								}
								
                                // Depending which user updated the staff member, the provider may not be the correct one selected
                                // for the current user, so only update the none provider specific data.
                                // for (var attrname2 in staff.provider) {
                                //     this.$root.user.provider[attrname2] = staff.provider[attrname2];
                                // }
                            }
                            else {
                                this.$root.user[attrname] = staff[attrname];
                            }
                            
                        }
                    }
                    
                    if(!found) {
                        this.lookup.staff.push(staff);
                    }
                }
                //console.log("updateItem: " + found);
                return found;
            },
            addOrUpdateData(data) {
                var type = data.type;
                var subtypes = data.subtypes;
                var source = null;
                //console.log("Looking at data update: " + type);
                //console.log("subtypes: " + subtypes);
                switch(type) {
                    case "requests":
                        source = this.requests;
                        break;
                    default:
                        source = this.lookup[type];
                }
                if(source && Array.isArray(source)) {
                    console.log("Processing data update: " + type);
                    for(var dataIndex in data.items) {
                        var found = false;
                        for(var index in source) {
                            if(subtypes) {
                                for(var subtypeIndex in subtypes) {
                                    if(source[index][subtypes[subtypeIndex]] && source[index][subtypes[subtypeIndex]].id == data.items[dataIndex].id) {
                                        found = true;
                                        if(data.items[dataIndex].deleted_at) {
                                            delete(source[index][subtypes[subtypeIndex]]);
                                        }
                                        else {
                                            for (var attrname in data.items[dataIndex]) {
                                                source[index][subtypes[subtypeIndex]][attrname] = data.items[dataIndex][attrname];
                                            }
                                        }
                                    }
                                }
                            }
                            else {
                                if(source[index].id == data.items[dataIndex].id) {
                                    found = true;
                                    if(data.items[dataIndex].deleted_at) {
                                        source.splice(index, 1);
                                    }
                                    else {
                                        for (var attrname in data.items[dataIndex]) {
                                            source[index][attrname] = data.items[dataIndex][attrname];
                                        }
                                    }
                                }
                            }
                        }
                        if(!found && !subtypes) {
                            source.push(data.items[dataIndex]);
                            try {
                                if(data.items[dataIndex].name) {
                                    source = source.sort((a,b) => {return a.name.localeCompare(b.name)});
                                }
                            }
                            catch(e) {
                                // Hate to just ignore this, but this is a real general purpose updater,
                                // and it's possible that the sort will fail if some objects only have
                                // partial data (no "name" field). If they do, we don't really care. We
                                // can still use and see the new item.
                            }
                        }
                    }
                }
            },
            removeStaff(staff_id) {
                //console.info(staff_id);
                var found = false;

                if(this.lookup.staff && Array.isArray(this.lookup.staff)) {
                    //console.log("Processing request update.");
                    for(var index in this.lookup.staff) {
                        if(this.lookup.staff[index].id == staff_id) {
                            found = true;
                            this.lookup.staff.splice(index, 1);
                        }
                    }
                }
                //console.log("updateItem: " + found);
                return found;
            },
            freshdeskShowWidget() {
                if(window.FreshworksWidget) {
                    FreshworksWidget('open');
                }
            },
            lt_login(auth) {
                return axios.post('/ajaxlogin', auth).then((res) => {

                    //this.addNotification({type: "success", content: 'Logged in successfully'});

                    window.api_token = res.data.api_token;
                    this.api_token = window.api_token;

                    axios.defaults.headers.common['Authorization'] = 'Bearer ' + window.api_token;

                    this.loadCore(true);
                }).catch((error) => {
                    this.setLoading(false);
                    this.handleError(error, "create");

                    // console.log('test error on login user function');
                });
            },
            tableauEmbedPatch() {
                window.customElements.define(
                    "viz-filter",
                    class MyElement extends HTMLElement {}
                );
            },
            setBrand(app_type) {
                var custom_touch_icons = false;
                if(this.provider && this.provider.id) {
                    // var elements = document.querySelectorAll('[id^=custom_css_]');
                    // console.log(elements);
                    axios.get(`/api/v0/provider/brand_files/${this.provider.id}`, {}).then((res) => {
                        if(Array.isArray(res.data.files)) {
                            for(var index in res.data.files) {
                                switch(res.data.files[index]["extension"]) {
                                    case "css":
										[...document.querySelectorAll("[id^=custom_css_]")].map(n => n && n.remove());
                                        var file = document.createElement('link');
                                        file.rel = 'stylesheet';
                                        file.id = `custom_css_${index}`;
                                        file.href = res.data.files[index]["url"] + "?id=" + res.data.files[index]["cache_buster"];
                                        document.head.appendChild(file);
                                        break;
									case "png":
										var matches;
										if(res.data.files[index]["basename"] == `favicon-${app_type}.png`) {
											[...document.querySelectorAll("[id^=custom_favicon_]")].map(n => n && n.remove());
											var file = document.createElement('link');
											file.rel = 'icon';
											file.id = `custom_favicon_${index}`;
											file.type = 'image/png'
											file.href = res.data.files[index]["url"] + "?id=" + res.data.files[index]["cache_buster"];
											document.head.appendChild(file);
											
											var file = document.createElement('link');
											file.rel = 'shortcut icon';
											file.id = `custom_favicon_sc_${index}`;
											file.type = 'image/png'
											file.href = res.data.files[index]["url"] + "?id=" + res.data.files[index]["cache_buster"];
											document.head.appendChild(file);
										}
										else if((matches = res.data.files[index]["basename"].match(/^touch-icon-([0-9]+x[0-9]+)\.png$/))) {
											// If we find any custom touch icons, we delete all the previous ones and add the new ones.
											if(!custom_touch_icons) {
												[...document.querySelectorAll("[id^=custom_touch_icon_]")].map(n => n && n.remove());
												custom_touch_icons = true;
											}
											var file = document.createElement('link');
											file.rel = 'apple-touch-icon';
											file.id = `custom_touch_icon_${index}`;
											file.href = res.data.files[index]["url"] + "?id=" + res.data.files[index]["cache_buster"];
											file.sizes = matches[1];
											document.head.appendChild(file);
											
											var file = document.createElement('link');
											file.rel = 'icon';
											file.id = `custom_touch_icon_apple_${index}`;
											file.href = res.data.files[index]["url"] + "?id=" + res.data.files[index]["cache_buster"];
											file.sizes = matches[1];
											document.head.appendChild(file);
										}
                                        break;
                                }
                            }
                        }
                    }).catch((error) => {
                        this.handleError(error, "branding");
                    });
                }
            },
            checkArchive(user = this.$root.user, success) {
                if(Array.isArray(user.user_migration) && user.user_migration.find(obj => {
                    return obj.live_data_migrated_at && !obj.archived_data_migrated_at;
                })) {
                    this.$modal.show('dialog', {
                        title: this.$t('translations.migration_in_progress'),
                        text: this.is_patient() ? this.autobrand('translations.migration_in_progress_notice') : this.autobrand('translations.migration_in_progress_notice_provider'),
                    });
                }
                else {
                    success();
                }
                
            },
            showBreakout() {
                return this.embed_source || window.breakout;
            },
            breakout(url) {
                this.setLoading(true);
                
                return axios.post('/api/vp1/create-breakout-link', {url: window.location.href})
                    .then((res) => {
                        var breakout_url = res.data;
                        console.info(breakout_url);
                        this.setLoading(false);
                        setTimeout(() => {
                            if(typeof window.breakout === 'function') {
                                window.breakout(`https://${breakout_url}`);
                            }
                            else {
                                window.open(`https://${breakout_url}`, "_blank");
                            }
                        });
                    })
                    .catch((error) => {
                        this.setLoading(false);
                        this.handleError(error, "external link");
                        Promise.reject(error);
                    });
                
                // https://gist.github.com/felquis/a08ee196747f71689dcb
                
            }


        }
    }
</script>
